import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@uhg-abyss/web/ui/Modal';
import { Button } from '@uhg-abyss/web/ui/Button';
import { Layout } from '@uhg-abyss/web/ui/Layout';

export const PrimaryAccessAdminModal = ({
  isOpen,
  closeModal,
  handleApprove,
}) => {
  return (
    <Modal
      id="primary-access-modal"
      title="Would you like to become a Primary Access Administrator for this
      TaxId?"
      isOpen={isOpen}
      showCloseButton
      onClose={closeModal}
      footer={
        <Modal.Section>
          <Layout.Group alignLayout="right">
            <Button
              onClick={closeModal}
              borderRadius="23px"
              color="$primary1"
              variant="outline"
            >
              No, Cancel
            </Button>
            <Button
              onClick={handleApprove}
              borderRadius="23px"
              color="$primary1"
            >
              Yes, Confirm
            </Button>
          </Layout.Group>
        </Modal.Section>
      }
    >
      <Modal.Section>
        There is no active Primary Access Administrator(PAA) for this
        organization at this time. If you would like to become a PAA, please
        continue.
      </Modal.Section>
    </Modal>
  );
};

PrimaryAccessAdminModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleApprove: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
};
PrimaryAccessAdminModal.defaultProps = {
  isOpen: false,
};
